import { render } from "./StudentEditContainer.vue?vue&type=template&id=374588cb&ts=true"
import script from "./StudentEditContainer.vue?vue&type=script&lang=ts"
export * from "./StudentEditContainer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__